import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgOnlineTrainingOutlined = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {"\n    White Board Streamline Icon: https://streamlinehq.com\n  "}
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.8571 2.8571H13.143A1.143 1.143 0 0 1 14.2857 4v7.4286H1.7143V4A1.143 1.143 0 0 1 2.857 2.8571M.5714 11.4286h14.8572M8 2.8571V1.143M5.7143 11.4286 3.4286 14.857M10.2857 11.4286l2.2857 3.4285" />
    </g>
  </svg>
);
export default SvgOnlineTrainingOutlined;
